import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import LoginPage from './pages/Login';
import RegisterPage from './pages/Register';
import Dashboard from './pages/Dashboard';
import Teams from './pages/Teams';
import Activities from './pages/Activities';
import Profile from './pages/Profile';
import Tournaments from './pages/Tournaments';
import Statistics from './pages/Statistics';
import Sync from './pages/Sync';
import DashboardLayout from './layouts/DashboardLayout';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import ProtectedRoute from './components/ProtectedRoute';
import SystemSettings from './components/SystemSettings';
import { isAdmin } from './services/authService';
import StravaCallback from './components/StravaCallback';
import ExchangeTokenPage from './pages/ExchangeToken';
import UserManagement from './pages/UserManagement';
import FlagManagement from './pages/FlagManagement';
import TokenRefreshManager from './components/TokenRefreshManager';
import MaintenanceRankingPage from './pages/Statistics/MaintenanceRankingPage';

// Component bảo vệ cho trang chỉ dành cho admin
const AdminProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const userIsAdmin = isAdmin();
  
  if (!userIsAdmin) {
    return <Navigate to="/activities" />;
  }
  
  return <>{children}</>;
};

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <TokenRefreshManager />
        <Router>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route 
              path="/dashboard" 
              element={
                <ProtectedRoute>
                  <AdminProtectedRoute>
                    <DashboardLayout>
                      <Dashboard />
                    </DashboardLayout>
                  </AdminProtectedRoute>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/users" 
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <h1>Quản lý người dùng</h1>
                    <p>Đây là trang quản lý người dùng</p>
                  </DashboardLayout>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/teams" 
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <Teams />
                  </DashboardLayout>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/activities" 
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <Activities />
                  </DashboardLayout>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/profile" 
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <Profile />
                  </DashboardLayout>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/settings" 
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <h1>Cài đặt</h1>
                    <p>Thiết lập hệ thống</p>
                  </DashboardLayout>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/system-settings" 
              element={
                <ProtectedRoute>
                  <AdminProtectedRoute>
                    <DashboardLayout>
                      <SystemSettings />
                    </DashboardLayout>
                  </AdminProtectedRoute>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/tournaments" 
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <Tournaments />
                  </DashboardLayout>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/statistics" 
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <Statistics />
                  </DashboardLayout>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/sync" 
              element={
                <ProtectedRoute>
                  <AdminProtectedRoute>
                    <DashboardLayout>
                      <Sync />
                    </DashboardLayout>
                  </AdminProtectedRoute>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/user-management" 
              element={
                <ProtectedRoute>
                  <AdminProtectedRoute>
                    <DashboardLayout>
                      <UserManagement />
                    </DashboardLayout>
                  </AdminProtectedRoute>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/flag-management" 
              element={
                <ProtectedRoute>
                  <AdminProtectedRoute>
                    <DashboardLayout>
                      <FlagManagement />
                    </DashboardLayout>
                  </AdminProtectedRoute>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/tournaments/:tournamentId/rankings" 
              element={
                <ProtectedRoute>
                  <DashboardLayout>
                    <MaintenanceRankingPage />
                  </DashboardLayout>
                </ProtectedRoute>
              } 
            />
            <Route path="/strava-callback" element={<StravaCallback />} />
            <Route path="/exchange_token" element={<ExchangeTokenPage />} />
            <Route path="/" element={<Navigate to="/activities" replace />} />
          </Routes>
        </Router>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
